// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 1.06189C7.05369 1.55399 4 4.92038 4 9H11V1.06189Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13 1.06189V9H20C20 4.92038 16.9463 1.55399 13 1.06189Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20 11H4V15C4 19.4183 7.58172 23 12 23C16.4183 23 20 19.4183 20 15V11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mouse-filled')
export default class MouseFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mouse-filled',
    }
  }
}
